import React from "react";

const Presets = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="12.794" height="12.754" viewBox="0 0 12.794 12.754">
			<path
				id="icon-presets"
				d="M13.461,1.93a.309.309,0,0,0-.069.017.268.268,0,0,0-.069.026L1.144,8.062a.277.277,0,0,0,0,.5l12.179,6.089a.279.279,0,0,0,.242-.5l-1.946-.977a9.193,9.193,0,0,0,1.548-4.861,9.193,9.193,0,0,0-1.548-4.861l1.946-.977a.278.278,0,0,0-.1-.545ZM10.607,3.954A8.079,8.079,0,0,1,12.06,8.313a8.079,8.079,0,0,1-1.453,4.359L8.073,11.41a5.192,5.192,0,0,0,1.22-3.1,5.192,5.192,0,0,0-1.22-3.1ZM6.715,5.9a4.721,4.721,0,0,0-.744,2.413,4.721,4.721,0,0,0,.744,2.413L1.888,8.313Z"
				transform="translate(-0.984 -1.927)"
				fill="#fff"
				opacity="0.5"
			/>
		</svg>
	);
};

export default Presets;
